/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldChange } from './field-change';
import { PraticaEventoPayload } from './pratica-evento-payload';


export interface AggiornamentoPayload extends PraticaEventoPayload { 
    target?: AggiornamentoPayloadTargetEnum;
    target_id?: string;
    diff?: Array<FieldChange>;
}
export enum AggiornamentoPayloadTargetEnum {
    ANAGRAFICA_RICHIEDENTE = 'ANAGRAFICA_RICHIEDENTE',
    NUCLEO_FAMILIARE_COMPONENTE = 'NUCLEO_FAMILIARE_COMPONENTE',
    PRATICA_ROOT = 'PRATICA_ROOT'
};



